import React from 'react';
import classes from "./Spinner.module.css";

const Spinner = ({width,height,border}) => {
    return (
        <div className={classes.spinner} style={{width,height,borderWidth:border}}></div>
    )
}

export default Spinner